import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DataState {
  usu_acesso: string | null;
  usu_acesso_enc: string | null;
  error: boolean;
}

const initialState: DataState = {
  usu_acesso: null,
  usu_acesso_enc: null,
  error: false,
};

const dataSlice = createSlice({
  name: 'data',
  initialState,
  reducers: {
    setData: (
      state,
      action: PayloadAction<{ usu_acesso: string; usu_acesso_enc: string }>
    ) => {
      state.usu_acesso = action.payload.usu_acesso;
      state.usu_acesso_enc = action.payload.usu_acesso_enc;
    },
    setError: (state, action: PayloadAction<boolean>) => {
      state.error = action.payload;
    },
  },
});

export const { setData, setError } = dataSlice.actions;
export default dataSlice.reducer;
